// extracted by mini-css-extract-plugin
export default {"main":"Hero2_main__bA1jm","parent":"Hero2_parent__6dSgu","bt":"Hero2_bt__EitL8"};